<template>
  <div v-if="dataModel[props.brandExperience].carouselFull" class="carousel-full pb--50" :class="`carousel-full--${props.iteration}`">
    <div class="carousel-full__width">
      <div
        class="carousel-full__slide"
        v-for="(item, index) in dataModel[props.brandExperience].recipes"
        :key="item"
      >
        <div class="carousel-full__h1"
        :style="{
          color: dataModel[props.brandExperience].ui.primaryColor,
        }"> 
          {{dataModel[props.brandExperience].recipes[index].title}}
        </div>
        <div class="carousel-full__flexbox">
          <div
            class="carousel-full__column carousel-full__column--1"
            :data-id="index"
          >
            <div
              class="carousel-full__copy-columns"
              v-for="(item, label, key) in dataModel[props.brandExperience].recipes[props.brandExperience].copy"
              :key="item"
              
            >
              <div class="carousel-full__copy-col carousel-full__copy-column--1">
                <div
                  class="carousel-full__h2"
                  :style="{
                    color: dataModel[props.brandExperience].ui.primaryColor,
                  }"
                >
                  {{ label }}:
                </div>
              </div>
              <div class="carousel-full__copy-col carousel-full__copy-column--2">
                <div v-if="key + 1 === 1" class="width--100p">
                  <div
                    class="ta--left carousel-full__p width--100p"
                    v-for="item in dataModel[props.brandExperience].recipes[index].copy
                      .ingredients"
                    :key="item"
                  >
                    <span
                      :style="{
                        color: dataModel[props.brandExperience].ui.primaryColor,
                        fontWeight: 700,
                      }"
                      >{{ item.measure }}</span
                    > <span>{{ item.ingredient }}</span>
                  </div>
                </div>
                <div v-if="key + 1 === 2" class="width--100p">
                  <div
                    class="ta--left carousel-full__p"
                    v-for="item in dataModel[props.brandExperience].recipes[index].copy
                      .garnish"
                    :key="item"
                  >
                    <span v-html="item"></span>
                  </div>
                </div>
                <div v-if="key + 1 === 3" class="width--100p">
                  <div
                    class="ta--left carousel-full__p carousel-full__p--bullets"
                    v-for="item in dataModel[props.brandExperience].recipes[index].copy
                      .method"
                    :key="item"
                  >
                   <span v-html="item"></span>
                  </div>
                  <div
                    class="ta--left carousel-full__p carousel-full__p--additional"
                  >
                    GARNISH AND SERVE
                  </div>
                  <div class="ta--left carousel-full__units">
                    1 serve =
                    <span
                      :style="{
                        color: dataModel[props.brandExperience].ui.primaryColor,
                        fontWeight: 700,
                      }"
                      >{{
                        dataModel[props.brandExperience].recipes[index].units
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="carousel-full__column carousel-full__column--2"
            :data-id="index"
          >
            <img
              class="carousel-full__img--serve"
              :src="dataModel[props.brandExperience].recipes[index].image"
            />
          </div>
        </div>
      </div>
    </div>
    <img
      class="carousel-full__bottomBorder"
      :src="`./serves/carouselFull__bottomPattern--${props.brandExperience}.png`"
    />
  </div>
</template>

<script setup>
import dataModel from "../js/model.js";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
  iteration: {
    type: String,
    default: "1",
  },
});
var carouselIteration = "carousel-full--" + props.iteration;

$(document).ready(function () {
  $("." + carouselIteration)
  .prepend();
  $("." + carouselIteration)
  .append(
    `<img class="carousel-full__next--${props.iteration}" src="./serves/carouselFull__next--${props.brandExperience}.png">`
  );
  $(".carousel-full__width").slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".carousel-full__previous--" + props.iteration),
    nextArrow: $(".carousel-full__next--" + props.iteration),
    responsive: [
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.carousel-full {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  position: relative;
  width: 100%;
}
.carousel-full__width {
  max-width: 1124px;
  padding: 0px 50px;
  position: relative;
  width: 100%;
  @media (max-width: $width--s) {
    padding: 0px;
  }
}
.carousel-full__flexbox {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  width: 100%;
  @media (max-width: $width--s) {
    @include flex-direction(column-reverse);
    padding: 0px 25px;
  }
}
.carousel-full__slide {
  width: 100%;
}
.carousel-full__column {
  &--1 {
    @include flexbox();
    @include align-items(flex-start);
    @include justify-content(flex-start);
    @include flex-direction(column);
    width: 70%;
  }
  &--2 {
    @include flexbox();
    @include align-items(flex-start);
    @include justify-content(center);
    width: 30%;
    padding-bottom: 50px;
  }
  @media (max-width: $width--s) {
    padding-bottom: 0px;
    width: 100%;
  }
}
.carousel-full__copy-column--1, .carousel-full__copy-column--2 {
  @media (max-width: $width--xs) {
    width: 100%;
  }
}
.carousel-full__copy-columns {
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(flex-start);
  margin-top: 40px;
  @media (max-width: $width--s) {
    @include flex-direction(column);
  }
  @media (max-width: $width--xs) {
    width: 100%;
  }
}
.carousel-full__img--serve {
  width: 100%;
  @media (max-width: $width--s) {
    max-width: 100px;
  }
}
.carousel-full__h1 {
  font-family: termina, sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 32px;
  padding-bottom: 75px;
  text-align: center;
  width: 100%;
  @media (max-width: $width--xs) {
    padding: 0px 25px 50px 25px;
  }
}
.carousel-full__h2 {
  font-family: termina, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  width: 220px;
  @media (max-width: $width--s) {
    margin-bottom: 20px;
    width: 100%;
  }
  @media (max-width: $width--xs) {
    text-align: center !important;
    width: 100%;
  }
}
.carousel-full__p {
  font-size: 12px;
  letter-spacing: 1px;
  line-height: 18px;

  &:not(:first-child) {
    margin-top: 5px;
  }
  @media (max-width: $width--xs) {
    text-align: center !important;
    width: 100%;
  }


}
.carousel-full__p--additional {
  margin-top: 40px !important;
}
.carousel-full__units {
  font-size: 10px;
  line-height: 14px;
  margin-top: 40px;
  padding-bottom: 50px;
  @media (max-width: $width--xs) {
    text-align: center !important;
    width: 100%;
  }
}
.carousel-full__bottomBorder {
  bottom: 0px;
  position: absolute;
}
.carousel-full__next--2 {
  position: absolute;
  right: 20px;
  top: calc(50% - 18px);
  width: 50px;
  z-index: 120;
  @media (max-width: $width--xs) {
    top: 280px;
  }
}
.width--100p {
  width: 100%;
}
</style>